import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@ebw-monorepo/navigation';
import { GlobalLoadingService } from './services/global-loading.service';

@Component({
  selector: 'ebw-monorepo-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public publictitle = 'portale-saas';
  public title = 'PortaleSaaS';
  public globalLoading = false;

  constructor(public _loadingService: GlobalLoadingService, private navigation: NavigationService) {}

  ngOnInit() {
    this._loadingService.isGlobalLoading.subscribe((loading) => {
      this.globalLoading = loading;
    });

    this.navigation.startSaveHistory();
  }
}
